import { put, takeEvery, select } from 'redux-saga/effects';
import { push } from "connected-react-router";

import * as base from 'store/BaseSagas';
import * as actions from './actions';
import * as api from 'store/api/profile_sauna';


export function* watch() {
  yield takeEvery(actions.SAUNA_LIST_LOAD.START, actionListLoad);
  yield takeEvery(actions.SAUNA_DETAIL_LOAD.START, actionDetailLoad);
  yield takeEvery(actions.SAUNA_UPDATE.START, actionUpdate);
  yield takeEvery(actions.SAUNA_DELETE.START, actionDelete);
}

function* actionListLoad(action) {
  yield base.Request(action, api.saunaListLoad,
    {
      request: actions.saunaListLoadRequest,
      complete: actions.saunaListLoadComplete,
      error: actions.saunaListLoadError,
    },
  );
}

function* actionDetailLoad(action) {
  yield base.Request(action, api.saunaDetailLoad,
    {
      request: actions.saunaDetailLoadRequest,
      complete: actions.saunaDetailLoadComplete,
      error: actions.saunaDetailLoadError,
    },
  );
}

function* actionUpdate(action) {
  yield base.Request(action, api.saunaUpdate,
    {
      request: actions.saunaUpdateRequest,
      complete: actions.saunaUpdateComplete,
      error: actions.saunaUpdateError,
    },
    function* (data) {
      yield put(actions.saunaShowEditForm({ show: false }));
      if (!action.payload.preventLoadDetail) {
        yield put(actions.saunaDetailLoad({ id: data.id }));
        yield put(push(`/sauna/${data.id}`));
      } else {
        const filter = yield select((state) => state.sauna.filter);
        yield put(actions.saunaListLoad(filter));
      }
    }
  );
}

function* actionDelete(action) {
  yield base.Request(action, api.saunaDelete,
    {
      request: actions.saunaDeleteRequest,
      complete: actions.saunaDeleteComplete,
      error: actions.saunaDeleteError,
    },
    function* (data) {
      const filter = yield select((state) => state.sauna.filter);
      yield put(actions.saunaListLoad(filter));
    }
  );
}
